import React, {PureComponent} from 'react'
import './News.css'

class News1 extends PureComponent {
	render() {
		return (
			<div style={{maxWidth: '667px', margin: 'auto'}}>
				<div id="img-content">
					<h2 className="rich_media_title" id="activity-name">
						海外空中烹饪课堂横空出世！美未科技助力海外中餐传播
					</h2>
					<div className="rich_media_content" id="js_content">
						<section style={{
							letterSpacing: '0px',
							paddingRight: '6px',
							paddingLeft: '6px',
							fontSize: '16px',
							lineHeight: 2,
							boxSizing: 'border-box'
						}}>
							<section>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>谈及外国对中国的印象，除了功夫以外，最深入人心的可能就是中华美食了。</span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>一部《舌尖上的中国》不仅点燃了中国的社交媒体，也在国际上产生了很大的影响。</span>
								</p>
								<p>
									<br/>
								</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F11.jpeg"/>
							</section>
							<section>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>《舌尖》随便一集的截图都让人垂涎三尺 睡不着觉</span>
								</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F12.jpeg"/>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F13.jpeg"/>
								<p>
									<br/>
								</p>
							</section>
							<section>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>在YouTube上输入“Chinese Food”，可以看到一堆歪果仁好奇心爆棚对中国食物的试吃视频。</span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>反映欧美生活的电视剧中，时不时就会提到中国菜。</span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>外国知乎上有这么一个帖子。来自世界各地歪果仁们在此贴回复自己的亲身经历给出了各种对中国菜的评价。结果是——
										<strong>0差评！</strong>
										<br/>
									</span>
								</p>
								<p>
									<br/>
								</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F14.jpeg"/>
								<p>
									<br/>
								</p>
							</section>
							<section>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>在中华美食魅力的影响下，越来越多的外国人开始对中餐情有独钟。</span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>中餐被外国人喜闻乐见，但是，海外能中餐的厨师却。。。</span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}><strong>非常短缺！</strong></span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>在查找资料的时候小编发现……国内新闻对海外中餐从业人员短缺的现象从2011年报道到了2018年。。。</span>
								</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F15.jpeg"/>
								<p>
									<br/>
								</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F16.jpeg"/>
								<p>
									<br/>
								</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F17.jpeg"/>
								<p>
									<br/>
								</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F18.jpeg"/>
								<p>
									<br/>
								</p>
							</section>
							<section>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>欧美国家由于保护本地就业，对技术移民的要求越来越高，</span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>即使是在中餐从业人员市场需求量巨大的情况下。</span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>我们看到不少国家和地区已经有呼吁放宽中餐厨师的引进政策，</span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>但这个呼吁距离落地需要多久，又是一个问题，又是新一轮的等待……</span>
								</p>
								<p>
									<br/>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>这让不少海外的中餐馆望洋兴叹。</span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}><strong>仅仅是隔了一个大洋的距离，</strong></span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}><strong>海外的中国胃就辣么难被满足吗？</strong></span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}><strong>想吃一顿地道的中餐就那么难吗？</strong></span>
								</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F19.jpeg"/>
							</section>
							<section>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}><strong>气哭，哭到模糊</strong></span>
								</p>
								<p>
									<br/>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>于是。</span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>在此背景下，<strong>浙江侨联、美未传媒、浙商院</strong>坐下讨论一番决定：</span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}><strong>以食为媒</strong>，广泛调动海外民间力量，充分展示中华文化的“舌尖上的魅力”，不断向世界人民打开一扇活色生香的中国之窗。</span>
								</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F20.jpeg"/>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F21.jpeg"/>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F22.png"/>
							</section>
							<section>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}><strong>“海外空中烹饪课堂”由此诞生！</strong></span>
								</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F23.webp"/>
							</section>
							<section>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}><strong>第五期海外中餐烹饪技能培训班结课</strong></span>
								</p>
							</section>
							<section>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>海外空中烹饪课堂致力于培养海外中式烹饪专业技术人才——也就是说，这个课堂相当于提供了一个学习的平台，</span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}><strong>只要能够登陆这个平台，就会看到海量的中餐教学视频。</strong></span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>不管你在哪里，</span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>不管你年龄几何，</span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>不管你是哪国人，</span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>只要你想学习中餐，</span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}><strong>此平台都能满足你的需求。</strong></span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>而且<strong>第一期</strong>的视频全是</span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}><strong>免</strong></span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}><strong>费</strong></span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}><strong>的</strong></span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}><strong>。</strong></span>
								</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F24.webp"/>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F25.webp"/>
							</section>
							<section>
								<div className='text-center'>
									培训课上
								</div>
								<div className='text-center text-bold'>
									这些视频的提供者是浙江商学院——
								</div>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>浙江商学院的地位之于中餐烹饪界，</span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>不亚于蓝翔的地位之于挖掘机技术界。</span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>浙商院将在合作中重点提供美食烹饪技术的支持——重点发挥其浙菜教学、培训、研发等优势。</span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}><strong>这个平台的搭建者是美未传媒——</strong></span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>美未传媒作为“万家海外中餐馆行动计划”战略合作伙伴，对于中餐文化的海外推广一直不遗余力。</span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span
										style={{fontSize: '16px'}}>美未科技则在此次合作中利用美未科技对于海外大屏传播等技术，全力打造浙菜在线网络教学平台，双方开拓在烹饪培训和传播等方面的合作。</span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}>双方决定共同推动中国饮食——尤其是浙菜在海外的教学和传播。</span>
								</p>
								<p style={{textAlign: 'center'}}>
									<span style={{fontSize: '16px'}}><strong>中餐碰上互联网传媒，就是这么有魅力。</strong></span>
								</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F26.webp"/>
							</section>
							<section>
								<div className='text-center text-bold'>
									这次是喜极而泣
								</div>
								<br/>
								<div className='text-center'>
									刚刚提到的海外空中课堂第一期课程，
								</div>
								<div className='text-center'>
									一共有<strong>446个享有知识产权的高清中餐烹饪教学视频。目前已全部在美未海外传播平台上线。</strong>
								</div>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F27.webp"/>
							</section>
							<section>
								<br/>
							</section>
						</section>
					</div>
				</div>
			</div>
		)
	}
}

export default News1


// WEBPACK FOOTER //
// ./src/News1.js